import React from "react";
import Answers from "./Answers";
import { ReturnTextAndImg } from "./CheckImg";

export default function TestQuestion({question, length, writeAnswers, isPassed}) {
  let text = ReturnTextAndImg(question.name)
  return (
    <div key={`key${question.id}`} className="keen-slider__slide test-question">
      {/*<div className="test-question-wrapper" id={question.type}>*/}
      {/*  <p className="test-number-task">{question.number}/{length}</p>*/}
        <div style={{display:'flex', marginBottom:'20px', fontSize:'20px'}}>{/*Удалить стиль*/}
        {text}
        </div>
        <Answers type={question.type} data={question.answers} id={question.number} writeAnswers={writeAnswers} isPassed={isPassed}/>
        {/*<Answers type={question.type} data={question.answers} id={question.id} writeAnswers={writeAnswers} isPassed={isPassed}/> /!*поправить логику на сервре*!/*/}
      {/*</div>*/}
    </div>

  )
}
